module.exports = __webpack_public_path__ + "img/head_phones_white.a09a162e.svg";